import { Card, CardBody } from "@datapay-by-datacom/design-system";
import type { McpOverviewResponse } from "../../types";
import { formatNumber } from "../../utils/formatters";
import styles from "./McpOverviewCards.module.css";

interface KpiItemProps {
  label: string;
  value: number;
  accent?: string;
}

function KpiItem({ label, value, accent }: KpiItemProps) {
  return (
    <Card>
      <CardBody>
        <div className={styles.kpiItem}>
          <span className={styles.kpiLabel}>{label}</span>
          <span
            className={styles.kpiValue}
            style={accent ? { color: accent } : undefined}
          >
            {formatNumber(value)}
          </span>
        </div>
      </CardBody>
    </Card>
  );
}

export interface McpOverviewCardsProps {
  data: McpOverviewResponse;
}

export function McpOverviewCards({ data }: McpOverviewCardsProps) {
  return (
    <div className={styles.container}>
      <div className={styles.kpiGrid}>
        <KpiItem label="Total Interactions" value={data.total_interactions} />
        <KpiItem
          label="Unique Developers"
          value={data.unique_developers}
          accent="#14b8a6"
        />
        <KpiItem
          label="Unique Users"
          value={data.unique_users}
          accent="#6366f1"
        />
        <KpiItem
          label="Avg per Developer"
          value={data.avg_interactions_per_developer}
          accent="#8b5cf6"
        />
      </div>
    </div>
  );
}
